import SplitContent from 'Custom/Split/SplitContent';
import AjustableImage from 'Custom/AjustableImage';
import EFFECTIVE_IMAGE from 'Images/misc/effective-es.webp';
import EFFECTIVE_IMAGE_MOBILE from 'Images/misc/effective-mobile-es.webp';
import Button from 'Nori/Button';
import RichText from 'Custom/RichText';
import ExternalIcon from 'Images/brand-icons/external-icon.svg';
import styles from 'Custom/EffectiveSplit/index.module.scss';

const EffectiveSplit = ({ color = 'default', moduleNumber = '01' }) => {
  return (
    <SplitContent
      backgroundColor={color}
      className={styles.fixWidth}
      data-qa-tag="home-effective-wrapper-split"
      reverse
      data-design-visible="visible_vd"
      data-design-type="module"
      data-design-nori_id="Inline Content"
      data-design-module_name="NEXPLANON is just as effective as the pill without the daily hassle"
      data-design-module_no={moduleNumber}
    >
      <AjustableImage
        data-qa-tag="home-effective-wrapper-image"
        size="full"
        specialImage={true}
        imageMobile={{
          src: EFFECTIVE_IMAGE_MOBILE,
          style: { width: 265, height: 181 },
          alt: 'Over 99% Effective: Less Than 1 Pregnancy per 100 Women Who Used NEXPLANON® (etonogestrel implant) 68 mg Radiopaque for 1 Year',
        }}
        image={{
          src: EFFECTIVE_IMAGE,
          style: { maxWidth: 432 },
          alt: 'Over 99% Effective: Less Than 1 Pregnancy per 100 Women Who Used NEXPLANON® (etonogestrel implant) 68 mg Radiopaque for 1 Year',
        }}
      />
      <>
        <RichText data-qa-tag="home-effective-content-wrapper">
          <h2 data-qa-tag="home-effective-title" className="mb">
            NEXPLANON es tan eficaz como la píldora sin las molestias diarias
          </h2>
          <p className="body-text" data-qa-tag="home-effective-description">
            Es un anticonceptivo que no tiene que tomar cada día. NEXPLANON es
            un implante pequeño y flexible que previene el embarazo en mujeres
            por un período de hasta 5 años.† El estudio que extendió el uso de
            NEXPLANON por un período de hasta 5 años incluyó mujeres con
            distinto peso corporal.**
          </p>
          <p className="caption" data-qa-tag="home-effective-caption-1">
            <sup>†</sup>NEXPLANON se debe extraer hacia el final del quinto año.
          </p>
          <p className="caption" data-qa-tag="home-effective-caption-2">
            **Las mujeres con un peso superior al 130 % de su peso corporal
            ideal no fueron incluidas en los años 1-3 de los ensayos clínicos.
            En los años 4-5, las mujeres con un índice de masa corporal de entre
            17.2 y 64.3 kg/m2 fueron incluidas.
          </p>
        </RichText>
        <div className={styles.btnWrapper}>
          <Button
            data-qa-tag="home-effective-button"
            href="/effectiveness/"
            data-design-type="clickAction"
            data-design-category="button_vd"
            data-design-action="Button"
            data-design-label="Get the Details"
            data-design-nori_id="Inline Content"
            data-design-module_name="NEXPLANON is just as effective as the pill without the daily hassle"
            data-design-module_no={moduleNumber}
          >
            Conozca los detalles
          </Button>

          <Button
            data-qa-tag="home-redirection-to-english-button"
            href="/"
            data-design-type="clickAction"
            data-design-category="button_vd"
            data-design-action="Button"
            data-design-label="Find a Doctor"
            data-design-nori_id="Inline Content"
            data-design-module_name="NEXPLANON works by preventing ovulation"
            data-design-module_no="03"
            type="simple2"
          >
            Sitio en Ingles
            <ExternalIcon />
          </Button>
        </div>
      </>
    </SplitContent>
  );
};

export default EffectiveSplit;
